"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/fourFive/fourFiveUserActivityViewModel',["require", "exports", "knockout", "moment"], function (require, exports, ko, moment) {
    "use strict";

    var FourFiveUserActivityViewModel = function () {
        function FourFiveUserActivityViewModel(fourFiveUserActivity) {
            _classCallCheck(this, FourFiveUserActivityViewModel);

            this.created = ko.observable('');
            this.creator = ko.observable('');
            this.source = ko.observable('');
            this.sourceLine = ko.observable('');
            this.action = ko.observable('');
            this.tableName = ko.observable('');
            this.primaryKey = ko.observable('');
            this.changeDetails = ko.observable('');
            this.originalValue = ko.observable('');
            this.newValue = ko.observable('');
            this.reason = ko.observable('');
            this.update(fourFiveUserActivity);
        }

        _createClass(FourFiveUserActivityViewModel, [{
            key: "update",
            value: function update(fourFiveUserActivity) {
                this.created(moment(fourFiveUserActivity.created).format('DD/MM/YYYY HH:mm:ss'));
                this.creator(fourFiveUserActivity.creator);
                this.source(fourFiveUserActivity.source);
                this.sourceLine(fourFiveUserActivity.sourceLine);
                this.action(fourFiveUserActivity.action);
                this.tableName(fourFiveUserActivity.tableName);
                this.primaryKey(fourFiveUserActivity.primaryKey);
                this.changeDetails(fourFiveUserActivity.changeDetails);
                this.originalValue(fourFiveUserActivity.originalValue);
                this.newValue(fourFiveUserActivity.newValue);
                this.reason(fourFiveUserActivity.reason);
            }
        }, {
            key: "clear",
            value: function clear() {
                this.created('');
                this.creator('');
                this.source('');
                this.sourceLine('');
                this.action('');
                this.tableName('');
                this.primaryKey('');
                this.changeDetails('');
                this.originalValue('');
                this.newValue('');
                this.reason('');
            }
        }]);

        return FourFiveUserActivityViewModel;
    }();

    return FourFiveUserActivityViewModel;
});
//# sourceMappingURL=fourFiveUserActivityViewModel.js.map;
